import { render } from "./RichContentRenderer.vue?vue&type=template&id=1ff011e6&scoped=true"
import script from "./RichContentRenderer.vue?vue&type=script&lang=js"
export * from "./RichContentRenderer.vue?vue&type=script&lang=js"

import "./RichContentRenderer.vue?vue&type=style&index=0&id=1ff011e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff011e6"]])

export default __exports__